import { LAYOUT } from '../../constant'

const user = {
  path: '/renovation',
  redirect: '/renovation/index',
  component: LAYOUT,
  meta: {
    title: '子组件测试',
    orderNo: 2,
    hideChildrenInMenu: true
  },
  children: [
    {
      path: 'index',
      name: 'Renovation',
      component: () => import('@/views/Renovation.vue')
    }
  ]
}

export default user
